//import Moment from "moment";

const getCount = (state) => {
	return state.modelos.length;
}

export default {
	getCount
}